module.exports = __webpack_public_path__ + "img/emoji11.png";